export type WeekDay = {
  label: string;
  hours: string;
  /** The class format, or null on days with no class. */
  type: string | null;
};

export const WEEK_DAYS: WeekDay[] = [
  {
    label: "Lundi",
    hours: "19h30 - 21h00",
    type:"Gi / No-gi",
  },
  {
    label: "Mardi",
    // hours: "Aucun cours",
    hours: "---",
    type: null,
  },
  {
    label: "Mercredi",
    hours: "19h30 - 21h00",
    type: "Gi / No-gi",
  },
  {
    label: "Jeudi",
    // hours: "Aucun cours",
    hours: "---",
    type: null,
  },
  {
    label: "Vendredi",
    hours: "19h30 - 21h00",
    type: "Gi / No-gi",
  },
  {
    label: "Samedi",
    // hours: "Aucun cours",
    hours: "---",
    type: null,
  },
  {
    label: "Dimanche",
    hours: "14h00 - 15h30",
    type: "Gi / No-gi",
  },
];

export const CLASSES_PRIMARY_TEXT =
  "Notre programme vise premièrement à ce que nos élèves maitrises les bases du Jiu-Jitsu. Nous croyons fortement en l'efficacité de techniques simples, mais prouvées comme étant efficaces. Il est aussi incorporé au programme des techniques plus modernes telles que le berimbolo et la matrix, ainsi que de la lutte. Nos cours couvrent les projections au sol, ainsi que le combat au sol. Les cours suivent un programme de 12 mois permettant de perfectionner les différentes positions et techniques.";

export const CLASSES_SECONDARY_TEXT =
  "Contactez-nous pour les informations et pour planifier un cours d'essai!";

export type PriceRow = {
  price: string;
  voltBjj: string;
  accessHomaBjj: boolean;
};

export const CLASS_PRICES_18_PLUS: PriceRow[] = [
  {
    price: "225$ / 3 mois",
    voltBjj: "Illimité",
    accessHomaBjj: false,
  },
  {
    price: "120$ / 3 mois",
    voltBjj: "1 fois / semaine",
    accessHomaBjj: false,
  },
  {
    price: "390$ / 3 mois",
    voltBjj: "Illimité",
    accessHomaBjj: true,
  },
];

export const CLASS_PRICES_13_17: PriceRow[] = [
  {
    price: "180$ / 3 mois",
    voltBjj: "Illimité",
    accessHomaBjj: false,
  },
  {
    price: "120$ / 3 mois",
    voltBjj: "1 fois / semaine",
    accessHomaBjj: false,
  },
  {
    price: "330$ / 3 mois",
    voltBjj: "Illimité",
    accessHomaBjj: true,
  },
];
